/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { CronRequest } from '../../models/cron-request';
import { JobCrons } from '../../models/job-crons';

export interface UpdateCron$Params {
   body: CronRequest;
}

export function updateCron(
   http: HttpClient,
   rootUrl: string,
   params: UpdateCron$Params,
   context?: HttpContext
): Observable<StrictHttpResponse<JobCrons>> {
   const rb = new RequestBuilder(rootUrl, updateCron.PATH, 'post');
   if (params) {
      rb.body(params.body, 'application/json');
   }

   return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
         return r as StrictHttpResponse<JobCrons>;
      })
   );
}

updateCron.PATH = '/api/weather/job/cron/replacement';
